import React from 'react';
import { connect } from 'react-redux';
import { selector } from 'apps/services';
import PropTypes from 'prop-types';
import { BasePage } from 'components/core';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <BasePage>
      <div>
        {rest.app.get('loadingMessages').length > 0 && (
          <div className="notify-bar">
            {rest.app.get('loadingMessages').map((msg, idx) => {
              return <p key={idx}>{msg}</p>;
            })}
          </div>
        )}
        <Component {...rest} />
      </div>
    </BasePage>
  );
};

PrivateRoute.propTypes = {
  loggedInUser: PropTypes.object,
};

const mapStateToProps = (state) => selector(state, false, ['authorisation', 'app']);

export default connect(mapStateToProps)(PrivateRoute);
